import React, { type FC } from "react";
import BasicLinkButton from "../baseLinkButton/BasicLinkButton";
import { Icon } from "semantic-ui-react";

export interface AddUsersLinkButtonProps {
  onClick: () => void;
  disabled?: boolean;
  warning?: boolean;
}

const AddUsersLinkButton: FC<AddUsersLinkButtonProps> = ({ onClick, disabled, warning }) => (
  <div style={{ display: "flex", alignItems: "center" }}>
    <BasicLinkButton text="Add Users" iconClassName="fal fa-user" onClick={onClick} isDisabled={disabled} />
    {warning && <Icon size="large" className="fa fa-exclamation-circle" />}
  </div>
);

export default AddUsersLinkButton;
